import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import cns from '../../node_modules/classnames/index.js';

function Panel({ className = '', children = null, alert = false, error = false, info = false, success = false, }) {
    const classes = useMemo(() => cns('panel', {
        'panel--success': success,
        'panel--error': error,
        'panel--info': info,
        'panel--alert': alert,
    }, className), [success, error, info, alert, className]);
    return (jsx("div", { className: classes, children: jsx("div", { className: "panel__text", children: children }) }));
}

export { Panel as default };
